"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[168],{

/***/ 8168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EmailSignup; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71383);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66688);
/* harmony import */ var components_atoms_markdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61256);
/* harmony import */ var components_atoms_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6427);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46133);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);




var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var YellowBox = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].aside */ .ZP.aside(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(["\n  background: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  border-radius: 5px;\n  padding: 2rem;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  @media screen and (min-width: ", ") {\n    width: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGradient;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.shadow;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.textInverse;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.lg.minWidth;
}, function (_ref5) {
  var $isFullWidth = _ref5.$isFullWidth;
  return $isFullWidth ? '100%' : '66%';
});
var Title = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].span */ .ZP.span(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(["\n  font-weight: bold;\n  font-size: ", "; ;\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.desktopFontSize.subTitle;
});
var EmailInputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .ZP.div(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(["\n  background: rgba(196, 196, 196, 0.4);\n  border-radius: 5px;\n  height: 40px;\n  display: flex;\n  flex-direction: row;\n  padding: 0;\n  width: 100%;\n"])));
var EmailInput = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].input */ .ZP.input(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(["\n  border: 0;\n  flex: 1;\n  padding: 0.25rem 1rem;\n  background: transparent;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n  overflow: hidden;\n  font-size: 16px;\n  color: ", ";\n\n  &:focus-visible {\n    outline: none;\n  }\n  &:focus-within {\n    outline: 1px solid rgba(0, 0, 0, 0.25);\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.placeholder;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.placeholder;
});
var SubmitButton = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].button */ .ZP.button(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(["\n  margin: 0.5rem;\n  background: ", ";\n  border: 0;\n  border-radius: 5px;\n  width: 55px;\n  color: ", ";\n  cursor: pointer;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.pageBackground;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primary;
});
var CheckboxLabel = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].label */ .ZP.label(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(["\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem;\n  align-items: center;\n"])));

var required = function required(value) {
  return !!value ? undefined : 'This field is required';
};
/*
I consent to being contacted in accordance with SatsGoal&apos;s <a href="https://www.iubenda.com/privacy-policy/68396819" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.

*/


function EmailSignup(_ref11) {
  var title = _ref11.title,
      privacyText = _ref11.privacyText,
      emailPlaceholder = _ref11.emailPlaceholder,
      postSignUpText = _ref11.postSignUpText,
      isFullWidth = _ref11.isFullWidth;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      submitted = _useState[0],
      setSubmitted = _useState[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(YellowBox, {
    $isFullWidth: isFullWidth,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Title, {
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__.Form, {
      onSubmit: /*#__PURE__*/function () {
        var _ref12 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(values) {
          var resp;
          return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return axios__WEBPACK_IMPORTED_MODULE_5___default().post('/api/email-signup', values);

                case 2:
                  resp = _context.sent;
                  if (resp.status === 200) setSubmitted(true);

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref12.apply(this, arguments);
        };
      }(),
      render: function render(_ref13) {
        var handleSubmit = _ref13.handleSubmit;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("form", {
          onSubmit: handleSubmit,
          style: {
            display: 'flex',
            gap: '1rem',
            flexDirection: 'column'
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__.Field, {
            name: "consentGiven",
            type: "checkbox",
            validate: required,
            children: function children(_ref14) {
              var input = _ref14.input,
                  meta = _ref14.meta;
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_atoms_form__WEBPACK_IMPORTED_MODULE_4__.StyledField, {
                error: meta.touched && meta.error,
                style: {
                  width: '100%'
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(CheckboxLabel, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("input", _objectSpread({
                    style: {
                      accentColor: 'white',
                      color: 'black'
                    }
                  }, input)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_atoms_markdown__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    onPrimaryBg: true,
                    children: privacyText
                  })]
                })
              });
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__.Field, {
            name: "email",
            type: "email",
            validate: required,
            children: function children(_ref15) {
              var input = _ref15.input,
                  meta = _ref15.meta;
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_atoms_form__WEBPACK_IMPORTED_MODULE_4__.StyledField, {
                error: meta.touched && meta.error,
                style: {
                  width: '100%'
                },
                children: submitted ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_atoms_markdown__WEBPACK_IMPORTED_MODULE_3__["default"], {
                  onPrimaryBg: true,
                  children: postSignUpText
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(EmailInputWrapper, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(EmailInput, _objectSpread(_objectSpread({}, input), {}, {
                    placeholder: emailPlaceholder
                  })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(SubmitButton, {
                    type: "submit",
                    "aria-label": "Submit",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("svg", {
                      style: {
                        width: '100%',
                        height: '100%'
                      },
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 512 512",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                        d: "M502.6 278.6l-128 128c-12.51 12.51-32.76 12.49-45.25 0c-12.5-12.5-12.5-32.75 0-45.25L402.8 288H32C14.31 288 0 273.7 0 255.1S14.31 224 32 224h370.8l-73.38-73.38c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l128 128C515.1 245.9 515.1 266.1 502.6 278.6z",
                        fill: "currentColor"
                      })
                    })
                  })]
                })
              });
            }
          })]
        });
      }
    })]
  });
}

/***/ })

}]);